import { useEffect } from 'react';
import i18n from '@/i18n';
import { useQueryClient } from '@tanstack/react-query';

export function LanguageQueryBridge() {
  const qc = useQueryClient();
  
  useEffect(() => {
    const handler = () => {
      console.log('[LanguageQueryBridge] Language changed, invalidating article queries');
      // Invalidate all article queries
      qc.invalidateQueries({ queryKey: ['articles'] });
      qc.invalidateQueries({ queryKey: ['article'] });
      qc.invalidateQueries({ queryKey: ['publishedInterviews'] });
    };
    
    i18n.on('languageChanged', handler);
    return () => i18n.off('languageChanged', handler);
  }, [qc]);
  
  return null;
}